<template>
    <div class="datagl">
        <div class="top">
            <div>
                <p>用户名</p>
                <el-input v-model="usernameinput" placeholder="请输入内容" size="mini"></el-input>
            </div>
            <div>
                <p>姓名</p>
                <el-input v-model="realnameinput" placeholder="请输入内容" size="mini"></el-input>
            </div>

            <el-button size="mini" @click="search">查询</el-button>
            <el-button size="mini" @click="add">新增</el-button>


        </div>
        <div class="bottom">
            <el-table :data="tableData" height="500" border style="width: 100%">
                <el-table-column prop="username" label="用户名" width="180">
                </el-table-column>
                <el-table-column prop="name" label="姓名">
                </el-table-column>
                <el-table-column prop="phone" label="手机">
                </el-table-column>
                <el-table-column prop="email" label="邮箱">
                </el-table-column>
                <el-table-column prop="is_active" label="状态">
                </el-table-column>
                <el-table-column prop="is_superuser" label="是否管理员">
                </el-table-column>


            </el-table>
        </div>
        <el-dialog title="新增" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <div class="addform">
                <div>
                    <p>用户名：</p>
                    <el-input v-model="addusername" placeholder="请输入内容" size="mini"></el-input>
                </div>
                <div>
                    <p>密&emsp;码：</p>
                    <el-input type="password" v-model="addpassword" placeholder="请输入密码" size="mini"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
export default {
    data() {
        return {
            token: "",
            username: "",
            tableData: [],
            realnameinput: "",
            usernameinput: "",
            dialogVisible: false,
            addusername: "",
            addpassword: ""
        }
    },
    methods: {

        // 获取用户
        getuser() {
            const _this = this
            this.$axios({
                method: "get",
                url: "/user/",
                params: {
                    username: _this.usernameinput
                },
                headers: {
                    "Authorization": _this.token.toString()
                }
            }).then(function (res) {
                console.log(res)
                var datalist = res.data.results
                for (let index = 0; index < datalist.length; index++) {

                    if (datalist[index].is_active == true) {
                        datalist[index].is_active = "可用"
                    } else {
                        datalist[index].is_active = "禁用"
                    }
                    if (datalist[index].is_superuser == true) {
                        datalist[index].is_superuser = "是"
                    } else {
                        datalist[index].is_superuser = "否"
                    }

                }
                _this.tableData = res.data.results
            })
        },
        // 新增
        add() {
            this.dialogVisible = true
        },
        // 查询
        search() {
            this.getuser()
        },
        // 提交
        submit() {
            if (this.addusername == "") {
                this.$message.error('请输入用户名');
            } else if (this.addpassword == "") {
                this.$message.error('请输入密码');
            } 
            else if (this.addpassword.trim().length<6 ) {
                this.$message.error('密码不能小于六位');
            } 
            else {
                const _this = this
                this.$axios({
                    method: "post",
                    url: "/user/",
                    data: {
                        username: _this.addusername,
                        password: _this.addpassword,
                    },
                    headers: {
                        "Authorization": _this.token.toString()
                    }
                }).then(function (res) {
                
                        _this.$message({
                            message: '新增成功',
                            type: 'success'
                        });
                        _this.dialogVisible = false
                        _this.getuser()
                        _this.addusername=""
                        _this.addpassword=""
                }).catch(function (error) {
                    _this.$message.error(error);
                })
            }

        }
    },
    mounted() {
        this.username = this.$Cookie.get("username")
        this.token = this.$Cookie.get("token")
        this.getuser()
    }
}
</script>
<style lang="scss">
.datagl {
    display: flex;
    flex-direction: column;
    height: 100%;

    .top {
        background-color: #fff;
        height: 80px;
        margin-bottom: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        display: flex;
        align-items: center;
        padding: 0 20px;

        div {
            display: flex;
            align-items: center;
            margin-right: 8px;

            p {
                margin-right: 8px;
            }

            .el-select {
                width: 120px;
            }

            .el-input {
                width: 120px;
            }
        }
    }

    .bottom {
        background-color: #fff;
        flex: 1;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        padding: 20px;
    }

    .importexcel {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;

        span {
            width: 200px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #66b1ff;

            color: #fff;
            cursor: pointer;
        }

        p {
            margin-bottom: 20px;
            cursor: pointer;
        }

        p:hover {
            color: #66b1ff;
        }
    }
}
.addform{
    display: flex;
    flex-direction: column;
    div{
        height: 45px;
        display: flex;
        align-items: center;
        // margin-bottom: 10px;
        .el-input{
            width: 150px;
        }
    }
}
</style>